$(document).on('click', '.tooltip-link', function(e) {
    e.preventDefault();
    var id = $(this).data('id');
    $(id).addClass('active');
});

$(document).on('click', '.tooltip-content .close', function(e) {
    e.preventDefault();
    $(this).parent().removeClass('active');
});
